<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <h1 class="display-1 font-weight-light">
              {{ $t("Dashboard.Title") }}
            </h1>
          </v-col>
        </v-row>
        <v-row class="pt-3">
          <v-col cols="12">
            <v-divider></v-divider>
            <h1 class="title font-weight-light pt-2">
              {{ $t("Dashboard.Sites_Title") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <simple-module
              :title="$t('Dashboard.Sites_Module')"
              icon="mdi-home-group"
              :loading="sitesLoading"
              :data="sites.length.toString()"
            ></simple-module>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimpleModule from "@/components/Dashboard/SimpleModuleComponent";
import SiteService from "@/services/SiteService";

export default {
  name: "Home",
  data() {
    return {
      sites: [],
      sitesLoading: true
    };
  },
  components: {
    SimpleModule
  },
  mounted() {
    SiteService.GetAllSites()
      .then(response => (this.sites = response.data))
      .catch(error =>
        this.$emit("show-error", this.$i18n.t("Error.Sites_Not_Retrieved"))
      )
      .finally(() => (this.sitesLoading = false));
  }
};
</script>
